// source: witbooking/backoffice/channelmanager/v1/channelmanager_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.displayName = 'proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.displayName = 'proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.displayName = 'proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.displayName = 'proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.displayName = 'proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.displayName = 'proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest;
  return proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelManagersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse;
  return proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addChannelManagers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelManagersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string channel_managers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.prototype.getChannelManagersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse} returns this
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.prototype.setChannelManagersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse} returns this
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.prototype.addChannelManagers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse} returns this
 */
proto.witbooking.backoffice.channel.v1.GetChannelManagersResponse.prototype.clearChannelManagersList = function() {
  return this.setChannelManagersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest;
  return proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelManagersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse;
  return proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addChannelManagers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelManagersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string channel_managers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.prototype.getChannelManagersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse} returns this
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.prototype.setChannelManagersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse} returns this
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.prototype.addChannelManagers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse} returns this
 */
proto.witbooking.backoffice.channel.v1.GetPropertyChannelManagersResponse.prototype.clearChannelManagersList = function() {
  return this.setChannelManagersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelManagersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest;
  return proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addChannelManagers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelManagersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string channel_managers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.prototype.getChannelManagersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} returns this
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.prototype.setChannelManagersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} returns this
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.prototype.addChannelManagers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest} returns this
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersRequest.prototype.clearChannelManagersList = function() {
  return this.setChannelManagersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse;
  return proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.channel.v1.UpdatePropertyChannelManagersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.witbooking.backoffice.channel.v1);
